<template>
  <b-input-group>
    <b-input-group-prepend is-text>
      <span style="font-size:14px;">$</span>
    </b-input-group-prepend>
    <input
      class="form-control col-md-12"
      type="text"
      :id="getFieldID(schema)"
      v-model="label"
      @change="format()"
      @change.native="format()"
      @input.native="format()"
      @input="format()"
      v-on:keyup="formatDot()"
      v-attributes="'input'"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
    >
  </b-input-group>
</template>

<script>
import jshelper from '@/libs/helper';
import numbro from 'numbro';
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
  data() {
    return {
      label: '',
    };
  },
  watch: {
    value() {
      this.setLabel();
    },
  },
  methods: {
    setLabel() {
      this.label = this.value ? jshelper.currency(this.value) : '';
    },
    formatDot() {
      const formatStr = this.label.replace(/[^\d.]/g, '');
      const value = formatStr.replace(/[^0-9]/g, '');
      if (value) {
        this.label = jshelper.currency(value, true);
      }
    },
    format() {
      const formattedValue = numbro(this.label.replace(/[^\d.]/g, ''));
      if (formattedValue.value()) {
        this.value = jshelper.currency(formattedValue, false);
      } else {
        this.value = '0';
        this.label = '';
      }
    },
  },
  created() {
    this.setLabel();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldCurrency.vue